import type {
  OrderSearchParams,
  RedoPrescription,
  ShipAddressChange,
  ShipAddressFields,
  ShipMethodChange,
} from "@types-runway/admin";

export const SEARCH_USER_BY_EMAIL = "SEARCH_USER_BY_EMAIL";
export const searchUserByEmail = (payload: any) => ({
  type: SEARCH_USER_BY_EMAIL,
  payload,
});
export const SEARCH_USER_BY_ID = "SEARCH_USER_BY_ID";
export const searchUserById = (payload: any) => ({
  type: SEARCH_USER_BY_ID,
  payload,
});
export const SEARCH_PARTNERS = "SEARCH_PARTNERS";
export const searchPartners = (payload: any) => ({
  type: SEARCH_PARTNERS,
  payload,
});
export const SEARCH_TRANSACTIONS = "SEARCH_TRANSACTIONS";
export const searchTransactions = (payload: any) => ({
  type: SEARCH_TRANSACTIONS,
  payload,
});
export const GET_CASES = "GET_CASES";
export const getCases = (payload: any) => ({
  type: GET_CASES,
  payload,
});
export const GET_CASES_BY_USER = "GET_CASES_BY_USER";
export const getCasesByUser = (payload: any) => ({
  type: GET_CASES_BY_USER,
  payload,
});
export const GET_ORDERS = "GET_ORDERS";
export const getOrders = (payload: any) => ({
  type: GET_ORDERS,
  payload,
});
export const SEARCH_ORDERS = "SEARCH_ORDERS";
export const searchOrders = (payload: OrderSearchParams) => ({
  type: SEARCH_ORDERS,
  payload,
});
export const FIND_SHIP_CASE = "FIND_SHIP_CASE";
export const findShipCase = (payload: { caseId: string }) => ({
  type: FIND_SHIP_CASE,
  payload,
});
export const FIND_REDO_ORDER = "FIND_REDO_ORDER";
export const findRedoOrder = (payload: { query: string }) => ({
  type: FIND_REDO_ORDER,
  payload,
});
export const LOAD_REDO_PRESCRIPTIONS = "LOAD_REDO_PRESCRIPTIONS";
export const loadRedoPrescriptions = (payload: { orderId: number }) => ({
  type: LOAD_REDO_PRESCRIPTIONS,
  payload,
});
export const LOAD_REDO_INVOICE = "LOAD_REDO_INVOICE";
export const loadRedoInvoice = (payload: { orderId: number }) => ({
  type: LOAD_REDO_INVOICE,
  payload,
});
export const CANCEL_REDO_ORDER = "CANCEL_REDO_ORDER";
export const cancelRedoOrder = (payload: { id: number; orderId: string; status: string | null }) => ({
  type: CANCEL_REDO_ORDER,
  payload,
});
export const REPLACE_REDO_ORDER = "REPLACE_REDO_ORDER";
export const replaceRedoOrder = (payload: {
  id: number;
  orderId: string;
  status: string | null;
  invoiceId: string;
  caseId: string;
  prescriptions: RedoPrescription[];
}) => ({
  type: REPLACE_REDO_ORDER,
  payload,
});
export const RESEND_REDO_ORDER = "RESEND_REDO_ORDER";
export const resendRedoOrder = (payload: {
  orderId: string;
  prescriptions: RedoPrescription[];
  invoiceId: string;
  caseId: string;
}) => ({
  type: RESEND_REDO_ORDER,
  payload,
});
export const UPDATE_SHIP_METHOD = "UPDATE_SHIP_METHOD";
export const updateShipMethod = (payload: ShipMethodChange) => ({
  type: UPDATE_SHIP_METHOD,
  payload,
});
export const LOAD_SHIP_ADDRESSES = "LOAD_SHIP_ADDRESSES";
export const loadShipAddresses = (payload: { userId: string }) => ({
  type: LOAD_SHIP_ADDRESSES,
  payload,
});
export const SAVE_SHIP_ADDRESS = "SAVE_SHIP_ADDRESS";
export const saveShipAddress = (payload: { userId: string; fields: ShipAddressFields }) => ({
  type: SAVE_SHIP_ADDRESS,
  payload,
});
// Creates an address on the found user, or updates one in place when it has an id (USER-R25).
export const SAVE_USER_ADDRESS = "SAVE_USER_ADDRESS";
export const saveUserAddress = (payload: { userId: string; fields: ShipAddressFields }) => ({
  type: SAVE_USER_ADDRESS,
  payload,
});
export const CHANGE_SHIP_ADDRESS = "CHANGE_SHIP_ADDRESS";
export const changeShipAddress = (payload: ShipAddressChange) => ({
  type: CHANGE_SHIP_ADDRESS,
  payload,
});
export const GET_PROMO_CODE = "GET_PROMO_CODE";
export const getPromoCode = (payload: any) => ({
  type: GET_PROMO_CODE,
  payload,
});
export const GET_REDEMPTIONS = "GET_REDEMPTIONS";
export const getRedemptions = (payload: any) => ({
  type: GET_REDEMPTIONS,
  payload,
});
export const DELETE_PARTNER = "DELETE_PARTNER";
export const deletePartner = (payload: any) => ({
  type: DELETE_PARTNER,
  payload,
});
export const CANCEL_ORDER = "CANCEL_ORDER";
export const cancelOrder = (payload: any) => ({
  type: CANCEL_ORDER,
  payload,
});

export const UPDATE_CASE_SHIPPING = "UPDATE_CASE_SHIPPING";
export const updateCaseShipping = (payload: any) => ({
  type: UPDATE_CASE_SHIPPING,
  payload,
});

export const UPDATE_CASE_ADDRESS = "UPDATE_CASE_ADDRESS";
export const updateCaseAddress = (payload: any) => ({
  type: UPDATE_CASE_ADDRESS,
  payload,
});

export const UPDATE_ORDER_SHIPPING_METHOD = "UPDATE_ORDER_SHIPPING_METHOD";
export const updateOrderShippingMethod = (payload: any) => ({
  type: UPDATE_ORDER_SHIPPING_METHOD,
  payload,
});

export const CREATE_USER_ADDRESS = "CREATE_USER_ADDRESS";
export const createUserAddress = (payload: any) => ({
  type: CREATE_USER_ADDRESS,
  payload,
});

export const UPDATE_USER_ADDRESS = "UPDATE_USER_ADDRESS";
export const updateUserAddress = (payload: any) => ({
  type: UPDATE_USER_ADDRESS,
  payload,
});

export const SEND_ADMIN_ORDER = "SEND_ADMIN_ORDER";
export const sendAdminOrder = (payload: any) => ({
  type: SEND_ADMIN_ORDER,
  payload,
});

export const REPLACE_ORDER = "REPLACE_ORDER";
export const replaceOrder = (payload: any) => ({
  type: REPLACE_ORDER,
  payload,
});
